import React from 'react'
import styled from 'styled-components'
import {List} from '@material-ui/core'
import PropTypes from 'prop-types'
import Response from './components/Response'

const ResponseList = styled(List)`
  display: flex;
  flex-direction: column;
  margin: 32px;
  width: 50%;
`

const ResponseBody = styled.div`
  display: flex;
  justify-content: center;
`

class ResponseContent extends React.Component {
  updateResponseMessage = newResponse => {
    const customResponseMessage = this.props.responseMessages.reduce(
      (ac, cv) => {
        if (cv.name === newResponse.name) {
          return [
            ...ac,
            {
              name: newResponse.name,
              message: newResponse.message.map(e => {
                return {type: e.type, value: e.value}
              }),
            },
          ]
        }
        if (cv.customMessage.length !== 0) {
          return [
            ...ac,
            {
              name: cv.name,
              message: cv.customMessage.map(e => {
                return {type: e.type, value: e.value}
              }),
            },
          ]
        }
        return ac
      },
      [],
    )
    this.props.newResponseGQL({
      variables: {
        projectId: this.props.projectId,
        responseMessage: customResponseMessage,
      },
    })
  }

  render() {
    return (
      <ResponseBody>
        <ResponseList>
          {this.props.responseMessages.map(message => {
            return (
              <Response
                key={message.name}
                responseMessage={message}
                updateResponseMessage={this.updateResponseMessage}
              />
            )
          })}
        </ResponseList>
      </ResponseBody>
    )
  }
}

ResponseContent.propTypes = {
  responseMessages: PropTypes.array.isRequired,
  projectId: PropTypes.string.isRequired,
}

export default ResponseContent



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/responseMessage/ResponseContent.js